import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const getMySignature = async () => {
  const service = getService(ServiceName.rms_user_signature);
  return await service.find();
};

export const setupSignature = async ({ signatureData, pin }) => {
  const service = getService(ServiceName.rms_user_signature);
  return await service.create({ signatureData, pin });
};

export const verifyPin = async (pin) => {
  const service = getService(ServiceName.rms_user_signature);
  return await service.patch('current', { action: 'verify-pin', pin });
};

export const changeSignature = async ({ pin, signatureData }) => {
  const service = getService(ServiceName.rms_user_signature);
  return await service.patch('current', { action: 'change-signature', pin, signatureData });
};

export const changePin = async ({ pin, newPin }) => {
  const service = getService(ServiceName.rms_user_signature);
  return await service.patch('current', { action: 'change-pin', pin, newPin });
};

export const deleteSignature = async (pin) => {
  const service = getService(ServiceName.rms_user_signature);
  return await service.remove('current', { query: { pin } });
};
